import { useQuery } from '@tanstack/react-query';
import { fetchQuestionBankTopics } from '../services/questionBankTopicService';

export function useQuestionBankTopics(params = {}, options = {}) {
  return useQuery({
    queryKey: ['questionBankTopics', params],
    queryFn: async () => {
      const { payload } = await fetchQuestionBankTopics(params);

      return {
        topicLang: payload?.topic_lang || 'Topics',
        subjectName: payload?.subject_name || '',
        stateName: payload?.state_name || '',
        categoryName: payload?.category_name || '',
        forceTopicsEnabled: Number(payload?.force_topics_enabled || 0),
        forceSubtopicsEnabled: Number(payload?.force_subtopics_enabled || 0),
        subTopicVisibilityStatus: Number(payload?.sub_topic_visibility_status || 0),
        subTopicToggleStatus: Number(payload?.sub_topic_toggle_status || 0),
        topicList: Array.isArray(payload?.topic_list) ? payload.topic_list : [],
        pagination: payload?.pagination || {},
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        topicLang: 'Topics',
        subjectName: '',
        stateName: '',
        categoryName: '',
        forceTopicsEnabled: 0,
        forceSubtopicsEnabled: 0,
        subTopicVisibilityStatus: 0,
        subTopicToggleStatus: 0,
        topicList: [],
        pagination: {},
      },
  });
}
